export default "__VITE_ASSET__BpO3p5lH__"